import type { FC } from 'react';
import { Box, Card, Grid, Typography } from '@material-ui/core';
import { Buyer } from '../../../contract-types/Buyer';
import { score } from 'src/lib/Utils';

interface Props {
  buyer: Buyer,
}

const QuickStats3: FC<Props> = ({ buyer }: Props) => (
  <Box
    sx={{
      backgroundColor: 'background.default',
      p: 3,
      mt: 2,
    }}
  >
    <Card>
      <Grid
        alignItems="flex-end"
        container
        justifyContent="space-between"
      >
        <Grid
          item
          md={4}
          sm={6}
          xs={12}
          sx={{
            borderRight: (theme) => (
              {
                md: `1px solid ${theme.palette.divider}`
              }
            ),
            borderBottom: (theme) => (
              {
                md: 'none',
                xs: `1px solid ${theme.palette.divider}`
              }
            ),
            p: 3,
            textAlign: 'center'
          }}
        >
          <Typography
            color="textPrimary"
            variant="h5"
            sx={{ mb: 2 }}
          >
            BUYER STATS
          </Typography>
        </Grid>
        <Grid
          item
          md={4}
          sm={6}
          xs={12}
          sx={{
            borderRight: (theme) => (
              {
                md: `1px solid ${theme.palette.divider}`
              }
            ),
            borderBottom: (theme) => (
              {
                md: 'none',
                xs: `1px solid ${theme.palette.divider}`
              }
            ),
            p: 3,
            textAlign: 'center'
          }}
        >
          <Typography
            color="textPrimary"
            variant="h5"
          >
            {score(buyer?.score)}
          </Typography>
          <Typography
            color="textSecondary"
            sx={{ mt: 1 }}
            variant="overline"
          >
            Buyer&lsquo;s Score
          </Typography>
        </Grid>
        <Grid
          item
          md={4}
          sm={6}
          xs={12}
          sx={{
            borderRight: (theme) => (
              {
                md: `1px solid ${theme.palette.divider}`
              }
            ),
            borderBottom: (theme) => (
              {
                md: 'none',
                xs: `1px solid ${theme.palette.divider}`
              }
            ),
            p: 3,
            textAlign: 'center'
          }}
        >
          <Typography
            color="textPrimary"
            variant="h5"
          >
            {buyer?.bought}
          </Typography>
          <Typography
            color="textSecondary"
            sx={{ mt: 1 }}
            variant="overline"
          >
            Finalized Transactions
          </Typography>
        </Grid>
      </Grid>
    </Card>
  </Box>
);

export default QuickStats3;
